import Phaser from 'phaser';

export default class Coronavirus extends Phaser.GameObjects.Sprite {
  constructor(scene, x, y) {
    super(scene, x, y, 'coronavirus');
    
    this.setScale(0.8);
    this.setOrigin(0.5, 1);
    this.scene.add.existing(this);
  }

  spread() {
    this.virus = this.scene.add.particles('coronavirus');
    this.virusEmitter = this.virus.createEmitter({
      x: this.x,
      y: this.y - 40,
      speed: { min: 250, max: 350 },
      angle: { min: -170, max: 10 },
      gravityY: 50,
      scale: { start: 0.3, end: 0.6, random: true },
      quantity: 1,
      frequency: 300,
      lifespan: 4000,
    });
  }

  stopSpread() {
    this.virusEmitter.stop();
  }
}

export function preload() {
  this.load.image(`coronavirus`, `characters/coronavirus.png`);
}
